import type { FieldComponent } from '@atlas/react-forms';
import { type ChangeEvent, useCallback, useState } from 'react';

import Errors from 'components/Form/Errors';

import Select from '../Select/Select';

import styles from './SelectField.module.scss';

const SelectField: FieldComponent = ({ field, onChange, onBlur, onFocus }) => {
  const [showError, setShowError] = useState(false);
  const initialValue = field.value?.toString() ?? '';

  const isValidField = !field?.errors?.length;

  const handleChangeValue = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      onChange?.(e.target.value, true);
    },
    [onChange],
  );

  const handleBlur = () => {
    onBlur?.();
    setShowError(true);
  };

  const handleFocus = () => {
    onFocus?.();
    setShowError(false);
  };

  return (
    <div className={styles['select-field-container']}>
      <Select
        value={initialValue}
        onChange={handleChangeValue}
        autoFocus={field.autofocus}
        name={field.name}
        id={field.name}
        onBlur={handleBlur}
        onFocus={handleFocus}
        isValid={isValidField}
        options={field.options}
        disabled={field.disabled || !field.isModifiable}
      />
      {showError && <Errors errors={field.errors} />}
    </div>
  );
};

export default SelectField;
